import type {
	CommentShared,
	CommentTranslations,
} from "Infrastructure/Translation/Types/comment";

const commentSharedTranslation: CommentShared = {
	confirmationModal: {
		title: "Delete comment",
		message: "Do you really want to delete this comment?",
		cancel: "Cancel",
		delete: "Delete",
	},
};

export const commentTranslations: CommentTranslations = {
	shared: commentSharedTranslation,
};
